import { FC } from 'react';

import { FormattedMessage } from 'dibs-react-intl';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { Button } from 'dibs-elements/exports/Button';

import { SET_STEP, STEP_LOGIN, DispatchType } from './reducer';

import sharedStyles from './styles/shared.scss';

type Props = {
    dispatch: DispatchType;
};

const IFramedPromoPartnershipAuthError: FC<Props> = ({ dispatch }) => {
    const handleClick = (): void => {
        dispatch({ type: SET_STEP, step: STEP_LOGIN });
    };

    return (
        <HeadingLevel>
            {Heading => (
                <div className={sharedStyles.wrapper}>
                    <div className={sharedStyles.header}>
                        <BarHeader
                            htmlElementType={Heading}
                            title={
                                <FormattedMessage
                                    id="iFramedpromoPartnership.IFramedPromoPartnershipAuthError.title"
                                    defaultMessage="Something went wrong. Please try again later."
                                />
                            }
                        />
                    </div>
                    <Button
                        dataTn="promo-partnership-auth-error-try-again"
                        className={sharedStyles.button}
                        onClick={handleClick}
                    >
                        <FormattedMessage
                            id="iFramedpromoPartnership.IFramedPromoPartnershipAuthError.button"
                            defaultMessage="Try Again"
                        />
                    </Button>
                </div>
            )}
        </HeadingLevel>
    );
};

export default IFramedPromoPartnershipAuthError;
